enum RunStatus {
  Scheduled = "scheduled",
  Running = "running",
  Completed = "completed",
  Failed = "failed",
  Paused = "paused",
  Cancelled = "cancelled",
}

export { RunStatus };
